"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeLink = exports.BadgeButton = exports.Badge = void 0;
var core_1 = require("@emotion/core");
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
var colors_1 = __importDefault(require("../tokens/colors"));
var fontSizes_1 = __importDefault(require("../tokens/fontSizes"));
var fontWeights_1 = __importDefault(require("../tokens/fontWeights"));
var letterSpacings_1 = __importDefault(require("../tokens/letterSpacings"));
var radii_1 = __importDefault(require("../tokens/radii"));
var spacing_1 = __importDefault(require("../tokens/spacing"));
var variations = {
    default: {
        textColor: colors_1.default.contentInverse,
        background: colors_1.default.bgNeutral,
        backgroundHovered: colors_1.default.bgNeutralHovered,
        backgroundPressed: colors_1.default.bgNeutralPressed,
    },
    primary: {
        textColor: colors_1.default.contentInverse,
        background: colors_1.default.bgPrimary,
        backgroundHovered: colors_1.default.bgPrimaryHovered,
        backgroundPressed: colors_1.default.bgPrimaryPressed,
    },
    neutral: {
        textColor: colors_1.default.contentPrimary,
        background: colors_1.default.bgNeutralSubtle,
        backgroundHovered: colors_1.default.bgNeutralSubtleHovered,
        backgroundPressed: colors_1.default.bgNeutralSubtlePressed,
    },
    passed: {
        textColor: colors_1.default.green800,
        background: colors_1.default.green200,
        backgroundHovered: colors_1.default.green300,
        backgroundPressed: colors_1.default.green400,
    },
    failed: {
        textColor: colors_1.default.contentLight,
        background: colors_1.default.red500,
        backgroundHovered: colors_1.default.red600,
        backgroundPressed: colors_1.default.red700,
    },
    warning: {
        textColor: colors_1.default.bronze800,
        background: colors_1.default.bronze300,
        backgroundHovered: colors_1.default.bronze400,
        backgroundPressed: colors_1.default.bronze500,
    },
    purple: {
        textColor: colors_1.default.purple800,
        background: colors_1.default.purple200,
        backgroundHovered: colors_1.default.purple300,
        backgroundPressed: colors_1.default.purple400,
    },
};
var BadgeStyles = function (_a) {
    var size = _a.size, variation = _a.variation;
    var _b = variations[variation], textColor = _b.textColor, background = _b.background;
    return (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    padding: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: uppercase;\n    border-radius: ", ";\n    color: ", ";\n    background-color: ", ";\n    white-space: nowrap;\n    width: fit-content;\n  "], ["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    padding: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n    text-transform: uppercase;\n    border-radius: ", ";\n    color: ", ";\n    background-color: ", ";\n    white-space: nowrap;\n    width: fit-content;\n  "])), size === 'small'
        ? "0 ".concat(spacing_1.default.space8)
        : "".concat(spacing_1.default.space4, "\n        ").concat(spacing_1.default.space8), size === 'small' ? '0.625rem' : "".concat(fontSizes_1.default.fontsize12), fontWeights_1.default.medium, spacing_1.default.space16, size === 'small'
        ? letterSpacings_1.default.badgeSmall
        : letterSpacings_1.default.badgeDefault, radii_1.default.circle, textColor, background);
};
var InteractiveBadgeStyles = function (_a) {
    var variation = _a.variation;
    var _b = variations[variation], background = _b.background, backgroundHovered = _b.backgroundHovered, backgroundPressed = _b.backgroundPressed;
    return (0, core_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-decoration: none;\n    border: none;\n    outline: none;\n\n    &[data-hovered] {\n      background: ", ";\n    }\n\n    &[data-pressed] {\n      background: ", ";\n    }\n\n    &[data-disabled] {\n      background: ", ";\n      cursor: not-allowed;\n    }\n\n    &[data-focus-visible] {\n      outline: ", " solid ", ";\n      outline-offset: ", ";\n    }\n  "], ["\n    text-decoration: none;\n    border: none;\n    outline: none;\n\n    &[data-hovered] {\n      background: ", ";\n    }\n\n    &[data-pressed] {\n      background: ", ";\n    }\n\n    &[data-disabled] {\n      background: ", ";\n      cursor: not-allowed;\n    }\n\n    &[data-focus-visible] {\n      outline: ", " solid ", ";\n      outline-offset: ", ";\n    }\n  "])), backgroundHovered, backgroundPressed, background, theme_1.borderWidths.thick, colors_1.default.blue400, spacing_1.default.space2);
};
var BadgeStyled = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), BadgeStyles);
var BadgeLinkStyled = (0, styled_1.default)(react_aria_components_1.Link)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), BadgeStyles, InteractiveBadgeStyles);
var BadgeButtonStyled = (0, styled_1.default)(react_aria_components_1.Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), BadgeStyles, InteractiveBadgeStyles);
var Badge = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.variation, variation = _c === void 0 ? 'default' : _c, children = _a.children;
    return (React.createElement(BadgeStyled, { size: size, variation: variation }, children));
};
exports.Badge = Badge;
var BadgeButton = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.variation, variation = _c === void 0 ? 'default' : _c, children = _a.children, props = __rest(_a, ["size", "variation", "children"]);
    return (React.createElement(BadgeButtonStyled, __assign({ size: size, variation: variation }, props), children));
};
exports.BadgeButton = BadgeButton;
var BadgeLink = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.variation, variation = _c === void 0 ? 'default' : _c, children = _a.children, props = __rest(_a, ["size", "variation", "children"]);
    return (React.createElement(BadgeLinkStyled, __assign({ size: size, variation: variation }, props), children));
};
exports.BadgeLink = BadgeLink;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map